import { connect } from 'react-redux';
import { memo } from 'react';
import { compose } from 'recompose';
import {
    selectEventCurrency,
    selectSeatsEnabled,
    selectAllTicketTypes,
} from '%evp_ticket_frontend/js/redux/currentEvent';
import {
    selectAllTicketTypeColors,
} from '%paysera_seat_selection_integration/js/seatings/redux/components/orm/selectors';
import CartItemList from './CartItemList';

export default compose(
    connect(
        state => ({
            ticketTypes: selectAllTicketTypes(state),
            ticketTypeColors: selectAllTicketTypeColors(state),
            currency: selectEventCurrency(state),
            seatsEnabled: selectSeatsEnabled(state),
        }),
        null,
    ),
    memo,
)(CartItemList);
